import React from 'react';

import Message from './Message';

export { Message };
export const ErrorMessage: React.FC = ({children}) => <Message type="error">{children}</Message>;
